import React from 'react';
import { css } from '@emotion/core';
import { Row } from 'antd';
import PropTypes from 'prop-types';
import { inject, observer } from 'mobx-react';
import ENUMS from '../../../constants/enums';
import { Indication1, MarketCard } from './styled';

@inject('ebayOAuthConnection')
@inject('onboardingStore')
@inject('settingsStore')
@observer
class MarketplaceSelector extends React.Component {
  handleChange = value => {
    this.props.handleChoice(value);
  };

  render() {
    const { formatCss, locationName } = this.props;

    const {
      ebayOAuthConnection: { marketplace },
      settingsStore: {
        markets: { destinationTypes },
      },
    } = this.props;

    return (
      <div
        css={css`
          ${formatCss};
        `}
      >
        <Indication1 />
        <Row style={{ display: 'flex', justifyContent: 'space-between', marginTop: '20px' }}>
          {destinationTypes.map(market =>
            market.id === 'AMAZON' && locationName === 'UNITED_KINGDOM' ? (
              ''
            ) : (
              <MarketCard
                type={`${market.name.toLowerCase()}/${market.name.toLowerCase()}`}
                key={market.id}
                highlighted={marketplace === ENUMS.MARKETS[market.id]}
                clickHandler={() => this.handleChange(ENUMS.MARKETS[market.id])}
              />
            ),
          )}
        </Row>
      </div>
    );
  }
}

MarketplaceSelector.propTypes = {
  handleChoice: PropTypes.func,
  ebayOAuthConnection: PropTypes.object,
  settingsStore: PropTypes.object,
};

export default MarketplaceSelector;
